// extracted by mini-css-extract-plugin
export default {"layout":"panelLayout_layout__CEVtW","outletWrapper":"panelLayout_outletWrapper__puO2r"};